import type { ReactNode } from 'react';

import './super-admin-navigation.css';

const superAdminPages = [
  {
    id: 'admin-announcements',
    label: 'Announcements',
    icon: <path d="M4.5 11.5h3l8-4.5v10l-8-4.5h-3v-1Zm3 1v4.25a1.75 1.75 0 0 0 3.5 0V14" />,
  },
  {
    id: 'admin-organisations',
    label: 'Organisations',
    icon: (
      <>
        <path d="M4.5 20V5.5h10V20M14.5 10.5h5V20M2.5 20h19" />
        <path d="M8 9h3M8 13h3M8 17h3M17 14h.01M17 17h.01" />
      </>
    ),
  },
  {
    id: 'admin-people',
    label: 'People',
    icon: (
      <>
        <path d="M8.5 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.25 1a2.5 2.5 0 1 0 0-5" />
        <path d="M3 20v-2.25A3.75 3.75 0 0 1 6.75 14h3.5A3.75 3.75 0 0 1 14 17.75V20M15.5 14h.75A3.75 3.75 0 0 1 20 17.75V20" />
      </>
    ),
  },
] as const;

export type SuperAdminPageId = (typeof superAdminPages)[number]['id'];

export function SuperAdminNavigation({
  activePage,
  visible,
  onNavigate,
}: {
  activePage: SuperAdminPageId | null;
  visible: boolean;
  onNavigate: (page: SuperAdminPageId) => void;
}) {
  if (!visible) return null;

  return (
    <nav aria-label="Super Administrator" className="super-admin-navigation">
      <p>Super Administrator</p>
      {superAdminPages.map((page) => (
        <a
          aria-current={activePage === page.id ? 'page' : undefined}
          className={activePage === page.id ? 'active' : undefined}
          href={`#${page.id}`}
          key={page.id}
          onClick={(event) => {
            event.preventDefault();
            onNavigate(page.id);
          }}
        >
          <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
            {page.icon}
          </svg>
          {page.label}
        </a>
      ))}
    </nav>
  );
}

export function SuperAdminPageShell({
  eyebrow = 'Super Administrator',
  title,
  description,
  children,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <section className="super-admin-page-shell" aria-labelledby="super-admin-page-title">
      <header>
        <p className="eyebrow">{eyebrow}</p>
        <h1 id="super-admin-page-title">{title}</h1>
        {description ? <p>{description}</p> : null}
      </header>
      {children}
    </section>
  );
}
